<div *ngIf="isOpen" class="flex-column kukai-modal">
  <div class="content">
    <div class="flex-row top">
      <div class="flex-row button close" (click)="closeModal()"><img class="x"
          src="../../../../../assets/img/close-btn-x.png" />
      </div>
      <div class="flex-column text">
        <h1 class="title">{{ title }}</h1>
        <h2 class="secondary">Choose a provider</h2>
      </div>
    </div>
    <div class="flex-column buy">
      <div class="flex-row option" (click)="buyTez(BuyProviderType.Coinbase)">
        <img src="assets/img/coinbase.png" />
        <div class="text">
          <h3>Coinbase</h3>
          <h4>Transfer from Coinbase</h4>
        </div>
        <svg class="verified" [class.active]="coinbaseVerified" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
          [attr.aria-label]="coinbaseVerified ? 'Wallet ownership verified' : 'Wallet ownership verification required'">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 1.5 3.75 4.6v6.15c0 5.36 3.52 10.02 8.25 11.75 4.73-1.73 8.25-6.39 8.25-11.75V4.6L12 1.5zm4.83 7.36-5.66 5.66a1 1 0 0 1-1.41 0l-2.59-2.59 1.41-1.41 1.88 1.88 4.96-4.95 1.41 1.41z" />
        </svg>
      </div>
      <div class="flex-row option" (click)="buyTez(BuyProviderType.Transak)">
        <img src="assets/img/transak.png" />
        <div class="text">
          <h3>Transak</h3>
          <h4>Bank transfers &amp; local payment methods in 120+ countries</h4>
        </div>
      </div>
      <div class="flex-row option" (click)="buyTez(BuyProviderType.MoonPay)">
        <img src="assets/img/moonpay.svg" />
        <div class="text">
          <h3>Moonpay</h3>
          <h4>Cards &amp; bank transfers</h4>
        </div>
      </div>
    </div>
  </div>
</div>